export default __webpack_public_path__ + "static/pwa-discuss-56ac3868b92a920a286176f4475c1115.webp";